import { RECAPTCHA_KEY } from "@gcloud-npm/utils.c2c";
import sendRetargeting from "@gcloud-npm/adabyron.misc.send-retargeting";
import FrontSonda from "@gcloud-npm/utils.monitoring.front-sonda";
import sendGaComponentEvent from '@gcloud-npm/utils.metrics.send-ga-component-event';

export const recaptchaActions = {
  RETARGETING: "retargeting_collect",
};

export const WEB_SERVICES = {
  RETARGETING: "retargeting",
};

export const HANDLING_CODES = {
  NOTHING_TO_DO: 1,
  FATAL: -1,
};

export const ERROR_PAGES = {
  DEFAULT: "default",
  CHECKOUT: "checkout",
};

export const webServiceErrorHandler = {
  [WEB_SERVICES.RETARGETING]: {
    service: WEB_SERVICES.RETARGETING,
    handlingCode: {
      default: HANDLING_CODES.NOTHING_TO_DO,
    },
    errorToPrint: ERROR_PAGES.DEFAULT,
  },
};

export const getClientsIds = (context) => {
  const { clientIDs } = { ...context };
  const { ga: client_id, sessionId: session_id } = { ...clientIDs };
  const ga = {};
  if (client_id) {
    ga.client_id = client_id;
  }
  // se incluye session_id solo si existe client_id y tiene formato correcto
  if (session_id && client_id) {
    const gaRegex = /^\d+\.\d+$/;
    if (gaRegex.test(client_id)) {
      ga.session_id = session_id;
    }
  }
  let gaIds = "";
  if (Object.keys(ga).length > 0) {
    gaIds = JSON.stringify(ga);
  }
  return gaIds;
};

export const getReCaptchaToken = ({ action = "default" }) => {
  return new Promise((resolve) => {
    if (typeof window === "undefined" || !window.grecaptcha) {
      resolve(null);
    }
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(RECAPTCHA_KEY, { action }).then((token) => {
        resolve(token);
      });
    });
  });
};

export const reportJSError = (error, processName, filePath, context) => {
  try {
    if (error instanceof Error) {
      const sonda = new FrontSonda({
        processName,
        filePath,
        context,
      });
      sonda.errorMessage({ error });
    }
  } catch (e) {
    // Nothing to do
  }
};

export const normalizeErrorInfo = (error, service, contextApi) => {
  const errorInfo = { ...webServiceErrorHandler[service] };
  try {
    const { handlingCode } = { ...errorInfo };
    const { status: errorCode } = { ...error };
    errorInfo.handlingCode = handlingCode[errorCode] || handlingCode.default;
    return errorInfo;
  } catch (e) {
    reportJSError(e, "normalizeErrorInfo", "utils/saga-utils", contextApi);
    return { ...errorInfo, handlingCode: -1 };
  }
};




export const sendToRetargeting = async (context, data, idForm) => {
  const { contextURL } = { ...context };
  const { phone, name, dni, email, consentimiento } = data;
  delete data.phone;
  delete data.name;
  delete data.dni;
  delete data.email;
  delete data.consentimiento;
  const consents = [];
  consents.push({text: consentimiento, acceptance: true})
  const dataPayload = {
    campaign: {
      id: idForm,
    },
    products: [],
    context: {
      url: btoa(contextURL || window.location.href),
      ga: getClientsIds(context),
    },
    contactInfo: {
      phone: phone,
      name: name,
      dni: dni,
      email: email,
      consents,
    },
    additionalInfo: JSON.stringify(data)
  };
  const recaptchaToken = await getReCaptchaToken({
    action: "retargeting_collect",
  });

  return sendRetargeting({ data: { ...dataPayload, recaptchaToken }, context });
};

export const sendTaggingInfo = (taggingInfo, eventType, eventName = null) => {
    const finalTaggingInfo = {
      ...taggingInfo,
      eventType,
    };
    try {
      const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
      const isFrontApp = typeof window !== 'undefined';
      const isMetricsDevEnable =
        isFrontApp && window.location.search.indexOf('metrics') > -1;
      if ((isFrontApp && currentEnv !== 'dev') || isMetricsDevEnable) {
        if (eventName) {
          sendGaComponentEvent(finalTaggingInfo, { eventType: eventName });
        } else {
          sendGaComponentEvent(finalTaggingInfo);
        }
      }
    } catch (err) {
      const sonda = new FrontSonda({
        processName: `-${process.env.NEXT_PUBLIC_PROJECT_ID}`,
        filePath: `input-${window.location.href}`,
      });
      sonda.errorMessage(err);
      throw err;
    }
  };


  export const conversePeopleMapIntoString = (map) => {
    try {
        var res = '';
        map.forEach(element => {
            if(element.age && element.gender) {
                res += `${res.length != 0 ? ' | ': ''}${element.label} ${element.gender}/${element.age}`
            }
        })
        return res  
    } catch (e) {
        return ''
    }
    
  }
  export const createDataObjet = (data) => {
    const res = {};
    Object.keys(data).forEach(key => {
        res[key] = data[key].value;
    });
    return res;
  }
